import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/jobTracking/job/${number | ':jobId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/jobTracking/job/:jobId`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/jobTracking/job/${jobId}`;
